import {Box, Text, Title} from '@mantine/core';
import Head from 'next/head';
import type React from 'react';
import {
  HOME_CRUMB,
  RECRUITING_INFO_CRUMB,
} from '../../../../../config/constants/crumb';
import {HOME, RECRUITING_INFO} from '../../../../../config/constants/routes';
import {BreadcrumbsComponent} from '../../../../../shared/components/BreadcrumbsComponent';
import {createBreadCrumbsStructuredData} from '../../../../../shared/services/createBreadCrumbsStructuredData';

type Props = {
  pageTitle: string;
};

export const HeaderForPC: React.FC<Props> = ({pageTitle}) => {
  const crumbs = [
    {label: HOME_CRUMB, href: HOME},
    {label: RECRUITING_INFO_CRUMB, href: RECRUITING_INFO},
  ];

  return (
    <Box className="w-[1200px] pt-8">
      <Box className="font-bold">
        <Head>
          <script type="application/ld+json">
            {JSON.stringify(createBreadCrumbsStructuredData(crumbs))}
          </script>
        </Head>
        <BreadcrumbsComponent crumbs={crumbs} />
      </Box>
      <Box className="my-16 h-[60px] flex flex-row items-center gap-x-12 bg-white px-16 py-4 shadow-card rounded-[16px]">
        <Title order={3} className="mr-16 text-2xl text-black leading-relaxed">
          {pageTitle}
        </Title>
        <Box className="flex flex-col">
          <Text className="text-black-1 text-base">
            トップ企業限定の本選考・説明会・セミナー情報を日々更新！まずはここをチェック！
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
